"use client"

import React from 'react';
import styles from "./SinglePath.module.css"
import Segments from "@/components/Segments/Segments";
import {useTranslations} from "use-intl";
import Cover from "@/components/Cover/Cover";
import Infos from "@/components/Infos/Infos";
import Preload from "@/components/SinglePath/Preload";
import usePathData from "@/utils/hooks/usePathData";
import {useGetFeaturedImage} from "@/utils/hooks/useGetFeaturedImage";
import UserPathStatus from "@/components/SinglePath/UserPathStatus/UserPathStatus";
import PathMap from "@/components/PathMap/PathMap";

export default function SinglePath(props: { id: string }) {
  const t = useTranslations("Path")
  const data = usePathData(props.id)
  const featured = useGetFeaturedImage(data?.images)
  if (!data) return <Preload/>

  const {id, name, content} = data

  return <div className={styles.container}>
    <div>
      <div className={styles.cover}>
        <UserPathStatus id={id}/>
        <Cover backElements={<h4>{t('walks')}</h4>} image={featured.url} link={`/cammini`} title={name}>
          <Infos data={data}/>
        </Cover>
      </div>
      <div className={"inner"}>
        <div className={styles.content} dangerouslySetInnerHTML={{__html: content}}/>
      </div>
    </div>
    <div>
      <PathMap id={String(id)}/>
      <h4 className={styles.segments}>{t('segments')}</h4>
      <Segments id={String(id)}/>
    </div>
  </div>
}
